import React from 'react'
import {
  string, number, func, arrayOf,
} from 'prop-types'
import Skeleton from 'react-loading-skeleton'
import styled from '@emotion/styled'

const WidthControlledImage = styled.img`
  max-width: 100%;
  @media (max-width: 600px) {
    max-width: none;
    max-height: 100%;
  }
`

const ImageWrapper = styled.div`
  display: flex;
  width: 100px;
  margin: 3px 32px 3px 3px;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
  padding: ${({ isSelected }) => (isSelected ? '0px' : '1px')};
  border: ${({ isSelected, theme }) => (isSelected ? `1px solid ${theme.colors.black}` : 'None')};
  @media (max-width: 600px) {
    margin: 4px;
    flex-direction: row;
    height: 200px;
    width: auto;
  }
`

const CarouselWrapper = styled.div`
  width: 136px;
  min-width: 136px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  /* Chrome */
  ::-webkit-scrollbar {
    width: 0px; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
  @media (max-width: 600px) {
    display: flex;
    width: auto;
    min-width: initial;
    overflow-x: scroll;
  }
`

const VerticalCarousel = ({ images, selected, onChange }) => (
  <CarouselWrapper>
    {images ? (
      images.map((img, index) => (
        <div key={img.url}>
          <ImageWrapper isSelected={index === selected} onClick={() => onChange(index)}>
            <WidthControlledImage src={img.url} alt="" />
          </ImageWrapper>
        </div>
      ))
    ) : (
      <Skeleton count={7} height={100} />
    )}
  </CarouselWrapper>
)

VerticalCarousel.propTypes = {
  images: arrayOf(string),
  selected: number.isRequired,
  onChange: func.isRequired,
}

VerticalCarousel.defaultProps = {
  images: null,
}

export default VerticalCarousel
